import React from 'react'
import IconBase from './IconBase'

const Calendar = props =>
  <IconBase viewBox="0 0 47.2 52.5" {...props}>
    <g transform="translate(-453 -1049)">
      <path d="m495 1054.2h-2.6v-5.2h-5.2v5.2h-21v-5.2h-5.2v5.2h-2.6c-2.9 0-5.2 2.3-5.2 5.2v36.7c0 2.9 2.3 5.2 5.2 5.2h36.6c2.9 0 5.2-2.3 5.2-5.2v-36.7c0-2.8-2.3-5.2-5.2-5.2zm0 42h-36.7v-28.9h36.7v28.9z"/>
      <path d="m488.5 1075.4l-2.8-2.8-12.8 12.8-5.6-5.6-2.8 2.8 8.3 8.3 15.7-15.5z"/>
    </g>
  </IconBase>

export default Calendar
